import {
  FormControl,
  ListItemText,
  MenuItem,
  Select,
  styled,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select/SelectInput";
import StewartCheckbox from "controls/global/stewart-checkbox";
import { CompanyLocationState as UiCompanyLocationState } from 'entities/UIModel/CompanyLocationState';
import React, {
  useState,
} from "react";
import { AgencyStatus } from "utils/data/enum";
import { capitalize } from "utils/shared";

interface Props {
  name: keyof UiCompanyLocationState;
  defaultValue: Array<AgencyStatus>;
  onChange: (name: string, value: string) => void;
}

const StyledSelect = styled(Select)({
  maxWidth: "100px",
  minWidth :"100px",
  width: "auto",
  "& .MuiSelect-iconOutlined": {
    right: "-1px",
  },
});

const options = [
  { id: AgencyStatus.Active, label: "Active" },
  { id: AgencyStatus.Inactive, label: "Inactive" },
];

const SelectStatus = ({ name, defaultValue, onChange }: Props) => {
  const [selectedValues, setSelectedValues] = useState<AgencyStatus[]>(defaultValue);

  const handleOnChange = (event: SelectChangeEvent<any>, child: React.ReactNode) => {
    const elValue = event.target.value as AgencyStatus[];
    const selectedValues =
      elValue.length > 0 ? elValue.join(",") : [AgencyStatus.Active, AgencyStatus.Inactive].join(",");

    setSelectedValues(elValue);
    onChange(name, selectedValues);
  };

  const getRenderValue = (selected: unknown) => {
    const statuses = (selected as AgencyStatus[]).map((s) => {
      return capitalize(s);
    });
    return statuses.join(", ");
  };

  return (
    <FormControl size="small">
      <StyledSelect
        name={name}
        disableUnderline
        fullWidth
        multiple
        variant="outlined"
        value={selectedValues}
        onChange={handleOnChange}
        renderValue={getRenderValue}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        {options.map((opt) => (
          <MenuItem
            key={opt.id}
            value={opt.id}
          >
            <StewartCheckbox checked={selectedValues.indexOf(opt.id) > -1} />
            <ListItemText primary={opt.label} />
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default SelectStatus;
